import { combineReducers } from 'redux'

import feedback from './feedback'
import customers from './customers'
import pages from './pages'
import user from './user'
import data, * as dataSelectors from './data'
import { LOGOUT } from 'actions'
import menuConfig from './menuConfig'
import featureToggles from './featureToggles'

const combinedReducers = combineReducers({
  feedback,
  customers,
  pages,
  data,
  user,
  menuConfig,
  featureToggles,
})

const rootReducer = (state, action) => {
  if (action.type === LOGOUT) {
    return combinedReducers(undefined, action)
  }

  return combinedReducers(state, action)
}

export default rootReducer

export const getCompanyId = (state) => dataSelectors.getCompanyId(state.data)

export const getFeedbackFilter = (state) => dataSelectors.getFeedbackFilter(state.data)

export const getCustomerFilter = (state) => dataSelectors.getCustomerFilter(state.data)

export const getIsZendeskIntegrationActive = (state) =>
  dataSelectors.getIsZendeskIntegrationActive(state.data)

export const getIsConnectwiseIntegrationActive = (state) =>
  dataSelectors.getIsConnectwiseIntegrationActive(state.data)

export const getAutotaskCredential = (state, surveyToken) =>
  dataSelectors.getAutotaskCredential(state.data, surveyToken)

export const getIsAutotaskIntegrationActive = (state, surveyToken) =>
  dataSelectors.getIsAutotaskIntegrationActive(state.data, surveyToken)

export const getIsSatisfactionRatingBackwardSyncActive = (state, surveyId) =>
  dataSelectors.getIsSatisfactionRatingBackwardSyncActive(state.data, surveyId)

export const getSurveySettingsFromId = (state, surveyId) =>
  dataSelectors.getSurveySettingsFromId(state.data, surveyId)

export const getSurveyFromId = (state, surveyId) =>
  dataSelectors.getSurveyFromId(state.data, surveyId)

export const getSurveyNameFromToken = (state, surveyToken) =>
  dataSelectors.getSurveyNameFromToken(state.data, surveyToken)

export const getSurveyFromToken = (state, surveyToken) =>
  dataSelectors.getSurveyFromToken(state.data, surveyToken)

export const getSurveyTokenFromId = (state, surveyId) =>
  dataSelectors.getSurveyTokenFromId(state.data, surveyId)

export const getSurveyTypeFromId = (state, surveyId) =>
  dataSelectors.getSurveyTypeFromId(state.data, surveyId)

export const hasSurveyByType = (state, surveyType) =>
  dataSelectors.hasSurveyByType(state.data, surveyType)

export const getAllSurveys = (state) => dataSelectors.getAllSurveys(state.data)

export const getNotificationFrequency = (state) =>
  dataSelectors.getNotificationFrequency(state.data)

export const getEmailSubscriptionId = (state) => dataSelectors.getEmailSubscriptionId(state.data)

export const getEmailSurveySubscriptionIds = (state) =>
  dataSelectors.getEmailSurveySubscriptionIds(state.data)

export const getEmailSurveySubscription = (state, ids) =>
  dataSelectors.getEmailSurveySubscription(state.data, ids)

export const getUsers = (state, currentUserId) => dataSelectors.getUsers(state.data, currentUserId)

export const getCurrentUserId = (state) => dataSelectors.getCurrentUserId(state.data)

export const getCurrentUserFullName = (state) => dataSelectors.getCurrentUserFullName(state.data)

export const getCurrentUserEmail = (state) => dataSelectors.getCurrentUserEmail(state.data)

export const getCustomerEntities = (state) => dataSelectors.getCustomerEntities(state.data)

export const getCustomer = (state, customerId) => dataSelectors.getCustomer(state.data, customerId)

export const getData = (state) => state.data

export function getUser(state) {
  return state.user
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/index.js